import React from 'react';
import { useDispatch } from 'react-redux';
import { useDrop } from 'react-dnd';

import * as selectedBlocksActions from '../../actions/selectedBlocks';
import * as selectedElementsActions from '../../actions/selectedElements';
import * as canvasActions from '../../actions/canvasBlocks';
import * as itemTypes from '../../constants/itemTypes/itemTypes';
import * as Styled from './styles';
import handleKeyPress from '../../common/handleKeyPress';
import { IBlock } from '../../types/content';

const BlockTrailsDropZone = () => {
    const dispatch = useDispatch();

    const [{ isOverCurrent }, drop] = useDrop({
        accept: [itemTypes.STATIC_BLOCK, itemTypes.CUSTOMIZED_BLOCK],
        drop: ({ newBlock, stateIndex }: { newBlock: IBlock; stateIndex: number }, monitor) => {
            const itemType = monitor.getItemType();
            if (itemType === itemTypes.STATIC_BLOCK) {
                dispatch(
                    canvasActions.addBlock({
                        block: newBlock,
                    })
                );
            }
            if (itemType === itemTypes.CUSTOMIZED_BLOCK) {
                dispatch(
                    canvasActions.swapBlocks({
                        draggedBlockIdx: stateIndex,
                    })
                );
            }
        },
        collect: (monitor) => ({
            isOverCurrent: monitor.isOver({ shallow: true }),
        }),
    });

    const onClick = (event: any) => {
        event.stopPropagation();
        dispatch(selectedElementsActions.removeAllSelectedElements());
        dispatch(selectedBlocksActions.removeAllSelectedBlocks());
    };

    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
            ref={drop}
            style={{ backgroundColor: isOverCurrent ? 'rgb(204, 204, 204)' : '#f4f3f3' }}
            onClick={(e) => onClick(e)}
            onKeyDown={(e) => handleKeyPress(e, () => onClick(e))}
        >
            <Styled.DropZoneBar isVisible={isOverCurrent} />
            <Styled.DropZone />
        </div>
    );
};

export default BlockTrailsDropZone;
